module.exports = __webpack_public_path__ + "static/media/Samsung-Galaxy-S8.033ecccd.jpg";